module.exports = __webpack_public_path__ + "img/Z86Q_17.330f30f3.jpg";